import { Svg } from "@impero-com/ui";

import { OrgCookie } from "../../utils/orgCookie";

import * as theme from "./theme.css";

const RightSideIcon = (props: RightSideIconProps) => {
    const orgCookie = props.customImages ? props.orgCookie : undefined;

    const backgroundPath =
        orgCookie && orgCookie.loginRightSideBackground
            ? "/org-img/" + orgCookie.loginRightSideBackground
            : undefined;

    const backgroundCSS = backgroundPath
        ? 'url("' + backgroundPath + '")'
        : undefined;

    // Do not fallback on default icon if background image is custom and custom logo is null
    const hideForeground = Boolean(
        orgCookie &&
        !orgCookie.loginRightSideLogo &&
        orgCookie.loginRightSideBackground
    );

    const customLogo =
        orgCookie && orgCookie.loginRightSideLogo
            ? orgCookie.loginRightSideLogo
            : undefined;

    const foreground = customLogo ? (
        <img className={theme.rightSideIcon} src={"/org-img/" + customLogo} />
    ) : (
        <Svg className={theme.rightSideIcon} src={props.icon} />
    );

    return (
        <div
            className={theme.rightSideIconContainer}
            style={
                backgroundCSS ? { backgroundImage: backgroundCSS } : undefined
            }
        >
            {hideForeground ? null : foreground}
        </div>
    );
};

interface CustomRightSideIconProps {
    icon: string;
    customImages: true;
    orgCookie: OrgCookie;
}

interface NonCustomRightSideIconProps {
    icon: string;
    customImages: false;
}

type RightSideIconProps =
    | CustomRightSideIconProps
    | NonCustomRightSideIconProps;

export default RightSideIcon;
